var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c_home_card"},[_c('div',{staticClass:"c_img",style:({backgroundImage: 'url(' + _vm.imgUrl + ')'})}),_c('div',{staticClass:"c_content"},[_c('div',{staticClass:"c_title"},[_vm._v(_vm._s(_vm.titleStr))]),_c('div',{staticClass:"c_desc"},[_vm._v(_vm._s(_vm.desc))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }